<template>
<div>
  <iframe id="iframeReport" name="iframeReport" style="height: 0; width: 0"></iframe>
   <section style="display: none" id="printableArea">
        <div>
            <div class="page_header">
                <hr class="m-t-0 m-b-20" />
            </div>
            <div class="m-b-20 receipt_details">
                <div class="columns m-b-0">
                    <div class="column is-12 p-t-0 p-b-0">
                        <div class="heading has-text-centered">
                            <h2 class="has-text-black-bis receipt_heading">Tax Invoice</h2>
                        </div>

                        <hr style="background-color: #191d38;height: 0.3rem;" class="m-t-7" />
                    </div>
                </div>
                <div class="columns">
                    <div class="column is-6 p-t-0 p-b-0">
                        <div class="invoice_details">
                            <hr class="m-b-10 m-t-10" />

                            <div class="customer_details p-t-10 m-l-15">
                                <div class="m-b-10 p-l-10">
                                    <h4 class="title is-5"><b>Invoice To</b></h4>
                                    {{franchiseeName}}
                                    <hr class="m-b-1 m-t-1" />
                                    {{franchiseeAddress}}
                                    <hr class="m-b-1 m-t-1" />
                                    {{franchiseeDistrict}}
                                    <hr class="m-b-1 m-t-1" />
                                    {{franchiseeState}}
                                    <hr class="m-b-1 m-t-1" />
                                    {{franchiseePincode}}
                                    <hr class="m-b-1 m-t-1" />
                                </div>
                                <table class="table is-fullwidth m-b-0">
                                    <tr>
                                        <th>Invoice No :</th>
                                        <td>
                                            <span>{{invoiceNo}} </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>GST No :</th>
                                        <td>
                                            <span>{{franchiseeGSTNo}} </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Place of Supply :</th>
                                        <td>{{franchiseeState}}</td>
                                    </tr>
                                    <tr>
                                        <th>Mobile No:</th>
                                        <td>{{franchiseeMobileNo}}</td>
                                    </tr>
                                    <tr v-if="irnNo">
                                        <th>IRN :</th>
                                        <td>
                                            <span>{{irnNo}}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Invoice Date :</th>
                                        <td>
                                            <span>{{invoiceDate}}</span>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="column is-6 m-l-15 p-l-30 p-r-30 p-b-0 p-t-0 border_dashed">
                        <div class="franchisee_details">
                            <table class="table is-fullwidth m-b-0">
                                <h4 class="title is-5"><b>Invoice From</b></h4>
                                <div class="columns m-b-0"></div>

                                <tr>
                                    <td>
                                      {{ conditionalCompanyName(invoiceDate) }}
                                        <hr class="m-b-1 m-t-1" />
                                        Rajashree Business Park,
                                        <hr class="m-b-1 m-t-1" />
                                        Plot No 114, Survey No 338,
                                        <hr class="m-b-1 m-t-1" />
                                        Tadiwala Road, Nr.Sohrab Hall,
                                        <hr class="m-b-1 m-t-1" />
                                        Pune - 411001, Maharashtra, India
                                        <hr class="m-b-1 m-t-1" />
                                        GST No. - 27AAECB1042N1ZQ
                                        <hr class="m-b-1 m-t-1" />
                                        Customer Care : +91-20-4466081000 or
                                        <hr class="m-b-1 m-t-1" />
                                        +91-20-7383738383
                                    </td>
                                </tr>
                                <tr>
                                  <td>
                                    <img style="width:10em;" class="image" v-if="qrCodeUrl !== null" :src="qrCodeUrl" alt="QR Code" />
                                  </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="bill_tables">
                        <hr />
                        <table class="table is-narrow is-fullwidth is-bordered">
                            <thead>
                                <tr>
                                    <th class="has-text-left" rowspan="0">Sr. No.</th>
                                    <th class="has-text-left" rowspan="0">Student Details</th>
                                    <th class="has-text-left" rowspan="0">Particulars</th>
                                    <th class="has-text-right" rowspan="0" v-if="sacCode">SAC Code</th>
                                    <th class="has-text-right" rowspan="0">Taxable</th>
                                    <th class="has-text-right" v-if="royaltyGstType === 'IGST'" rowspan="0">IGST Rate</th>
                                    <th class="has-text-right" v-if="royaltyGstType == 'IGST'" rowspan="0">IGST Amount</th>
                                    <th class="has-text-right" v-if="royaltyGstType !== 'IGST'" rowspan="0">CGST Rate</th>
                                    <th class="has-text-right" v-if="royaltyGstType !== 'IGST'" rowspan="0">CGST Amount</th>
                                    <th class="has-text-right" v-if="royaltyGstType !== 'IGST'" rowspan="0">SGST Rate</th>
                                    <th class="has-text-right" v-if="royaltyGstType !== 'IGST'" rowspan="0">SGST Amount</th>
                                    <th class="has-text-right" rowspan="0">Total Amount (including GST)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(installment, index) in paymentOrder" :key="index">
                                    <td class="has-text-left">{{index + 1}}</td>
                                    <td class="has-text-left">{{studentDetails.studentEnrollment.enrollmentCode}} | <strong>{{studentDetails.studentEnrollment.studentName}}</strong> | {{studentDetails.class}} | {{studentDetails.studentEnrollment.fatherEmailID}} | {{studentDetails.franchiseeAcademicYear.academicYear}} | Amount {{installment.assignFeeInstallment.amountRoyalty}} | Royalty %: {{calculateGSTRate(installment.assignFeeInstallment)}}</td>
                                    <td class="has-text-left">{{installment.assignFeeInstallment.feeTypeName}} - {{installment.assignFeeInstallment.name}}</td>
                                    <td class="has-text-right" v-if="sacCode">{{sacCode}}</td>
                                    <td class="has-text-right">{{installment.assignFeeInstallment.amountRoyalty}}</td>
                                    <td class="has-text-right" v-if="royaltyGstType === 'IGST'">{{Number(installment.assignFeeInstallment.royaltyIGST).toFixed(2)}} %</td>
                                    <td class="has-text-right" v-if="royaltyGstType === 'IGST'">{{calculateIGSTAmount(installment.assignFeeInstallment)}}</td>
                                    <td class="has-text-right" v-if="royaltyGstType !== 'IGST'">{{Number(installment.assignFeeInstallment.royaltyCGST).toFixed(2)}} %</td>
                                    <td class="has-text-right" v-if="royaltyGstType !== 'IGST'">{{calculateCGSTAmount(installment.assignFeeInstallment)}}</td>
                                    <td class="has-text-right" v-if="royaltyGstType !== 'IGST'">{{Number(installment.assignFeeInstallment.royaltySGST).toFixed(2)}} %</td>
                                    <td class="has-text-right" v-if="royaltyGstType !== 'IGST'">{{calculateSGSTAmount(installment.assignFeeInstallment)}}</td>

                                    <td class="has-text-right">{{calculateTotalAmount(installment.assignFeeInstallment)}}</td>
                                </tr>
                                <tr>
                                    <td colspan="4" class="has-text-right"><b>Grand Total </b></td>
                                    <td class="has-text-right"><b>{{calculateGrandTaxableAmount()}}</b></td>
                                    <td colspan="2" class="has-text-right" v-if="royaltyGstType === 'IGST'"><b>{{calculateTotalIGSTAmount()}}</b></td>
                                    <td colspan="2" class="has-text-right" v-if="royaltyGstType !== 'IGST'"><b>{{calculateTotalCGSTAmount()}}</b></td>
                                    <td colspan="2" class="has-text-right" v-if="royaltyGstType !== 'IGST'"><b>{{calculateTotalSGSTAmount()}}</b></td>
                                    <td class="has-text-right"><b>{{calculateGrandTotal()}}</b></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                <div class="print-bottom-content">
                    <v-row>
                      <v-col cols="12" md="12" lg="12" sm="12" xs="12">
                        <b> For, {{ conditionalCompanyName(invoiceDate) }}</b>
                      </v-col>
                      <v-col style="padding-top:0px;padding-bottom:0px;" cols="12" md="12" lg="12" sm="12" xs="12">
                          <b>
                              Registered Office : {{ conditionalCompanyName(invoiceDate) }},
                              <hr class="m-b-1 m-t-1" />
                              Rajashree Business Park,
                              <hr class="m-b-1 m-t-1" />
                              Plot No 114, Survey No 338,
                              <hr class="m-b-1 m-t-1" />
                              Tadiwala Road, Nr.Sohrab Hall,
                              <hr class="m-b-1 m-t-1" />
                              Pune - 411001, Maharashtra, India
                              <hr class="m-b-1 m-t-1" />
                              GST No. - 27AAECB1042N1ZQ
                              <hr class="m-b-1 m-t-1" />
                              Customer Care : +91-20-4466081000 or +91-20-7383738383

                          </b>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="12" md="12" lg="12" sm="12" xs="12">
                        <p style="text-align:center;"><b>This is Computer generated invoice</b></p>
                      </v-col>
                    </v-row>
                </div>
            </div>

        </div>
    </section>
</div>

</template>
<script src="/build/qrcode.min.js"></script>
<script lang="en">
    import moment from 'moment'
    import constants from '@/utils/constants'
    import helper from '@/utils/helper'
    import Utils from '@/utils'
    import _ from 'lodash'

    export default {
      name: 'printInvoiceFranchiseeToBB',
      props: ['printData'],
      data () {
        return {
          receiptNo: '',
          studentName: '',
          enrollmentCode: '',
          franchiseeName: '',
          franchiseeAddress: '',
          franchiseeDistrict: '',
          franchiseeState: '',
          franchiseePincode: '',
          franchiseeGSTNo: '',
          franchiseeMobileNo: '',
          invoiceNo: '',
          invoiceDate: '',
          irnNo: '',
          placeOfSupply: '',
          installments: [],
          sgstRate: null,
          cgstRate: null,
          gstType: null,
          igstRate: null,
          irnNo: "",
          sacCode: null,
          qrCodeUrl: null,
          qrCode: null,
          prtHtml: '',
          assignFeeInstallment:[],
          paymentOrder: null,
          royaltyGstType:''
        }
      },
      async created () {
        this.royaltyGstType = ''
        await this.setDetails()
      },
      methods: {
        setDetails: async function(){
          this.studentInfo = this.printData.studentInfo
          this.paymentOrder = this.printData.paymentOrder
          console.log(this.paymentOrder)
          this.paymentOrder.forEach(item => {
            if(
              this.royaltyGstType === '' &&
              item.assignFeeInstallment !== null &&
              item.assignFeeInstallment.royaltyGSTType &&
              item.assignFeeInstallment.royaltyGSTType !== null &&
              item.assignFeeInstallment.royaltyGSTType !== ''
            ){
              this.royaltyGstType = item.assignFeeInstallment.royaltyGSTType
            }
          })
          this.receiptNo = this.printData.paymentOrder[0].paymentOrder.receiptNo
          this.franchiseeName = this.studentInfo.franchisee.companyName
          this.franchiseeAddress = this.studentInfo.franchisee.address1
          this.franchiseeDistrict = this.studentInfo.franchisee.city
          this.franchiseeState = this.studentInfo.franchisee.state
          this.franchiseePincode = this.studentInfo.franchisee.pincode
          this.franchiseeGSTNo = this.studentInfo.franchisee.gstNo
          this.franchiseeMobileNo = this.studentInfo.franchisee.mobileno
          this.sgstRate = this.printData.paymentOrder[0].assignFeeInstallment.royaltySGST
          this.cgstRate = this.printData.paymentOrder[0].assignFeeInstallment.royaltyCGST
          this.gstType = this.printData.paymentOrder[0].assignFeeInstallment.royaltyGSTType
          this.igstRate = this.printData.paymentOrder[0].assignFeeInstallment.royaltyIGST
          this.qrCodeUrl = this.printData.qrCodeUrl
          let response = this.printData.eInvoiceDetails
          this.studentDetails=response.data.studentDetails
          this.sacCode = response.data.voucherType ? this.sacCode = response.data.voucherType.sacCode : null
          if (response.data && response.data.eInvoiceDetails) {

            this.invoiceNo = response.data.eInvoiceDetails.invoiceNo
            this.invoiceDate = moment(response.data.eInvoiceDetails.updatedAt).format('YYYY/MM/DD')
            this.irnNo = response.data.eInvoiceDetails.irnNo
          }
          else{
            this.invoiceNo = this.paymentOrder[0].paymentOrder.receiptNo
            this.invoiceDate = moment(this.paymentOrder[0].updatedAt).format('YYYY/MM/DD')
              if (response.data && response.data.voucherType) {
              this.sacCode = response.data.voucherType.sacCode
            }
          }
        },
        toFixed (number, length = 2) {
          return Number(Number(number).toFixed(length))
        },
        calculateTotalAmount(installment){
          let totalAmount = 0;
          totalAmount = Number(installment.amountRoyaltyPaid) + Number(installment.amountRoyaltyGSTPaid)
          return this.toFixed(totalAmount)
        },
        calculateGrandTaxableAmount(){
          let totalTaxableAmount = 0;
          _.forEach(this.paymentOrder, royalty => {
            totalTaxableAmount += Number(royalty.assignFeeInstallment.amountRoyalty)
          })
          return this.toFixed(totalTaxableAmount)
        },
        calculateGSTRate(installment){
          let gstRate = 0
          if (installment.royaltyGSTType === 'CGST-SGST') {
            gstRate = Number(installment.royaltyCGST) + Number(installment.royaltySGST)
          }
          if (installment.royaltyGSTType === 'IGST') {
            gstRate = Number(installment.royaltyIGST)
          }
          return this.toFixed(gstRate)
        },
        calculateCGSTAmount(installment){
          let cgstAmount = 0
          if (installment.royaltyGSTType === 'CGST-SGST') {
            cgstAmount = Number(installment.royaltyCGST)/100 * Number(installment.amountRoyalty)
          }
          return this.toFixed(cgstAmount)
        },
        calculateSGSTAmount(installment){
          let sgstAmount = 0
          if (installment.royaltyGSTType === 'CGST-SGST') {
            sgstAmount = Number(installment.royaltySGST)/100 * Number(installment.amountRoyalty)
          }
          return this.toFixed(sgstAmount)
        },
        calculateIGSTAmount(installment){
          let igstAmount = 0
          if (installment.royaltyGSTType === 'IGST') {
            igstAmount = Number(installment.royaltyIGST)/100 * Number(installment.amountRoyalty)
          }
          return this.toFixed(igstAmount)
        },
        calculateTotalCGSTAmount(){
          let totalCGSTAmount = 0
          _.forEach(this.paymentOrder, royalty => {
            if (royalty.assignFeeInstallment.royaltyGSTType === 'CGST-SGST') {
              totalCGSTAmount += Number(royalty.assignFeeInstallment.royaltyCGST)/100 * Number(royalty.assignFeeInstallment.amountRoyalty)
            }
          })
           return this.toFixed(totalCGSTAmount)
        },
        calculateTotalSGSTAmount(){
          let totalSGSTAmount = 0
          _.forEach(this.paymentOrder, royalty => {
            if (royalty.assignFeeInstallment.royaltyGSTType === 'CGST-SGST') {
              totalSGSTAmount += Number(royalty.assignFeeInstallment.royaltySGST)/100 * Number(royalty.assignFeeInstallment.amountRoyalty)
            }
          })
           return this.toFixed(totalSGSTAmount)
        },
        calculateTotalIGSTAmount(){
          let totalIGSTAmount = 0
          _.forEach(this.paymentOrder, royalty => {
            if (royalty.assignFeeInstallment.royaltyGSTType === 'IGST') {
              totalIGSTAmount += Number(royalty.assignFeeInstallment.amountRoyaltyGSTPaid)
            }
          })
           return this.toFixed(totalIGSTAmount)
        },
        calculateGrandTotal(){
          let grandTotal = 0
          _.forEach(this.paymentOrder, royalty => {
            grandTotal += Number(royalty.assignFeeInstallment.amountRoyaltyPaid)+Number(royalty.assignFeeInstallment.amountRoyaltyGSTPaid)
          })
          return this.toFixed(grandTotal)
        },
        isBefore (date1, date2) {
          date1 = moment(date1).format('YYYY-MM-DD')
          date1 = `${date1}T00:00:00.000Z`
          let d1 = new Date(date1)
          let d2 = new Date(date2)
          return d1 < d2
        },
        conditionalCompanyName: function (date){
          let companyName = ''
          if(this.isBefore(date, '2023-11-16T00:00:00.000Z')){
            companyName = 'Brainbees Solutions Pvt Ltd'
          } else if(this.isBefore(date, '2024-04-01T00:00:00.000Z')) {
            companyName = 'Brainbees Solutions Limited (Formerly known as Brainbees Solutions Pvt Ltd)'
          } else {
            companyName = 'Brainbees Solution Limited'
          }
          return companyName
        }
      }
    }
</script>
<style lang="scss" scoped>
@media print {
  #printableArea,
  #printableArea * {
    visibility: visible;
  }
  #printableArea {
    position: absolute;
    left: 0;
    top: 0;
  }
  #printableArea1,
  #printableArea1 * {
    visibility: visible;
  }
  #printableArea1 {
    position: absolute;
    left: 0;
    top: 0;
  }
}
    .page_header {
        .button {
            padding: 0.35rem 0.75rem;
            height: 2rem;
        }

        .icon.is-small .mdi {
            font-size: 16px;
        }
    }

    .receipt_details .bill_tables .footer_table .table.leftside tr td[data-v-ac24c7a6]:nth-child(1) {
        width: 0;
    }

    .button.has-text-info {
        width: auto !important;
    }

    .msg_div {
        width: auto !important;
    }

    .modal_table {
        table,
        th,
        td {
            width: 100%;
            border-collapse: collapse;
            border: 1px solid black;
            padding: 0.65rem 0.7rem;
            font-size: 1rem;
        }

        table {
            overflow-x: scroll;
            overflow-y: scroll;
        }

        td {
            display: table-cell;
            padding: 5px;
            color: black;
        }

        th {
            color: #fff;
            background-color: #56509f;
        }
    }

    .receipt_details {
        .receipt_heading {
            font-size: 1.3rem;
            font-weight: bold;
        }

        .sub_headings {
            color: seagreen;
        }

        .title.is-5 {
            color: black;
        }

        .hr_yellow {
            background-color: #191d38;
            height: 0.3rem;
        }

        .border_dashed {
            border-left: 1px dashed gray;
        }

        .customer_details,
        .franchisee_details {
            th {
                width: 10rem;
            }

            .table td,
            .table th {
                border: 0;
                padding: 0.3em 0.75em;
            }
        }

        .bill_tables {
            .table th {
                border: 1px solid #9a9a9a;
                background-color: #191d38;
                color: white;
                padding: 0.8em 0.75em;
            }

            .table td {
                padding: 0.8em 0.75em;
                border: 0.5px solid #9a9a9a;
            }

            caption {
                padding: 0.75rem;
                font-size: 1rem;
            }

            .footer_table {
                padding: 0 !important;

                .table td {
                    padding: 0.25rem 0.4rem;
                    border: 1px lightcyan;
                }

                .table.rightside tr {
                    td {
                        text-align: right;
                    }
                }

                .table.leftside tr {
                    // td:nth-child(1) {
                    //   width: 12rem;
                    // }
                    td:nth-child(2) {
                        padding-left: 1.5rem;
                        width: 5rem;
                    }
                }
            }
        }
    }
    .table.is-fullwidth {
        width: 94% !important;
    }
</style>
